import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
} from "../../../components/commons";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import {
  getBalanceSheetAction,
  resetAssetsBalanceSheetData,
  resetCustomerBalanceSheetData,
  resetEquityBalanceSheetData,
  resetLiabilitiesBalanceSheetData,
  resetPaymentBalanceSheetData,
  resetReportsError,
  resetReportsFetching,
  resetReportsSuccess,
  resetStockSummaryBalanceSheetData,
  resetSupplierBalanceSheetData,
  resetTaxPayableBalanceSheetData,
  resetTaxReceivableBalanceSheetData,
} from "../../../redux/reports";
import { resetSession } from "../../../redux/auth";
import BalanceSheetHeader from "../../../components/Reports/BalanceSheet/BalanceSheetHeader";
import {
  GetBalanceSheetPayloadType,
  GetMultipleLedgerStatementPdfType,
} from "../../../commonTypes/reportsTypes";
import {
  currencySignAndNegativeValueAdjust,
  formatDate,
  formatDateInYear,
  handleDate,
} from "../../../utils/commonFunctions";
import { BalanceSheetImage } from "../../../assets/images";
import {
  BalanceSheetDataType,
  BalanceSheetTotalType,
  StockSummaryDataType,
} from "../../../redux/reports/reportsType";
import { CapsHeader } from "../../../components/commons/CapsHeader";
import BalanceSheetTable from "../../../components/Reports/BalanceSheet/BalanceSheetTable/BalanceSheetTable";
import {
  BALANCE_SHEET_HEADERS,
  BALANCE_SHEET_STOCK_SUMMARY_HEADERS,
} from "../../../constant/tableHeadersConstants/reportsConstant/balanceSheetConstants/balanceSheetHeadersConst";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Excel } from "../../../components/Icon";
import moment from "moment";
import {
  downloadBalanceSheetApi,
  getMultipleLedgerStatementPdfApi,
} from "../../../apis/reportsApis";
import FileSaver from "file-saver";
import toast, { Toaster } from "react-hot-toast";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import ViewEditCustomerSuplierModal from "../../../components/Reports/LedgerStatement/ViewEditCustomerSuplierModal";
import {
  BusinessAddressListType,
  CustomerSupplierListType,
} from "../../../redux/clientSettings/clientSettingTypes";
import {
  GetAllBussinessAddressesListPayloadType,
  GetSingleCustomerSupplierListPayloadType,
} from "../../../commonTypes/clientSettingsTypes";
import {
  getAllBusinessAddressAction,
  getSingleCustomerSupplierAction,
  resetAllTypesLedgerListWithTaxList,
  resetBusinessAddressList,
} from "../../../redux/clientSettings";
import SkeltonElement from "../../../components/commons/SkeltonLoader/SkeltonElement";
import LedgerDownloadModal from "../../../components/commons/LedgerDownloadModal";

type AppProps = {
  history?: any;
  token: string | null;
  fetching: boolean;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  customerSuplierFetching: boolean;
  currencySign: string | undefined;
  companyName: string;
  assetsBalanceSheetData: [] | BalanceSheetDataType[];
  liabilitiesBalanceSheetData: [] | BalanceSheetDataType[];
  equityBalanceSheetData: [] | BalanceSheetDataType[];
  paymentBalanceSheetData: [] | BalanceSheetDataType[];
  supplierBalanceSheetData: [] | BalanceSheetDataType[];
  customerBalanceSheetData: [] | BalanceSheetDataType[];
  taxPayableBalanceSheetData: [] | BalanceSheetDataType[];
  taxReceiveableBalanceSheetData: [] | BalanceSheetDataType[];
  stockSummaryBalanceSheetData: [] | StockSummaryDataType[];
  singleCustomerSupplier: CustomerSupplierListType;
  balanceSheetTotal: BalanceSheetTotalType;
  businessAddressList: [] | BusinessAddressListType[];
  dispatchResetSession: () => void;
  dispatchResetReportsErrorAction: () => void;
  dispatchResetReportsSuccessAction: () => void;
  dispatchGetBalanceSheetAction: (data: GetBalanceSheetPayloadType) => void;
  dispatchResetBalanceSheetDataAction: () => void;
  dispatchResetCustomerBalanceSheetData: () => void;
  dispatchResetSupplierBalanceSheetData: () => void;
  dispatchResetPaymentBalanceSheetData: () => void;
  dispatchResetEquityBalanceSheetData: () => void;
  dispatchResetAssetsBalanceSheetData: () => void;
  dispatchResetLiabilityBalanceSheetData: () => void;
  dispatchResetTaxPayableBalanceSheetData: () => void;
  dispatchResetTaxReceivableBalanceSheetData: () => void;
  dispatchResetStockSummaryBalanceSheetData: () => void;
  dispatchResetReportsFetchingAction: () => void;
  dispatchResetAllTypeLedgerListWithTaxList: ()=>void;
  dispatchGetSingleCustomerSupplierAction: (
    data: GetSingleCustomerSupplierListPayloadType
  ) => void;
  dispatchGetAllBusinessAddressList: (
    data: GetAllBussinessAddressesListPayloadType
  ) => void;
  dispatchResetBusinessAddressList: () => void;
};
export type BranchListType = {
  value: number | string;
  label: string;
};
const BalanceSheet = ({
  history,
  token,
  fetching,
  statusCode,
  error,
  success,
  currencySign,
  companyName,
  customerSuplierFetching,
  singleCustomerSupplier,
  assetsBalanceSheetData,
  liabilitiesBalanceSheetData,
  equityBalanceSheetData,
  taxPayableBalanceSheetData,
  taxReceiveableBalanceSheetData,
  stockSummaryBalanceSheetData,
  paymentBalanceSheetData,
  supplierBalanceSheetData,
  customerBalanceSheetData,
  balanceSheetTotal,
  businessAddressList,
  dispatchResetReportsErrorAction,
  dispatchResetReportsSuccessAction,
  dispatchGetBalanceSheetAction,
  dispatchResetTaxPayableBalanceSheetData,
  dispatchResetTaxReceivableBalanceSheetData,
  dispatchResetStockSummaryBalanceSheetData,
  dispatchResetBalanceSheetDataAction,
  dispatchResetAssetsBalanceSheetData,
  dispatchResetCustomerBalanceSheetData,
  dispatchResetEquityBalanceSheetData,
  dispatchResetLiabilityBalanceSheetData,
  dispatchResetPaymentBalanceSheetData,
  dispatchResetSupplierBalanceSheetData,
  dispatchResetSession,
  dispatchResetReportsFetchingAction,
  dispatchGetSingleCustomerSupplierAction,
  dispatchGetAllBusinessAddressList,
  dispatchResetBusinessAddressList,
  dispatchResetAllTypeLedgerListWithTaxList
}: AppProps) => {
  const client_code = history?.location?.state?.client_code;
  const company_name = history?.location?.state?.company_name
    ? history?.location?.state?.company_name
    : companyName;
  const currentDate = formatDateInYear(new Date().toString());
  const [date, setDate] = useState(currentDate);
  const [displayDate, setDisplayDate] = useState("");
  const [liabilitiesTotal, setLiabilitiesTotal] = useState(0);
  const [isEditCustomerSupplierPresent, setIsEditCustomerSupplierPresent] =
    useMenuCheck();
  const [assetsTotal, setAssetsTotal] = useState(0);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [isLedgerStatementPresent, setIsLedgerStatementPresent] =
    useMenuCheck();
  const [isStocksStatementPresent, setIsStocksStatementPresent] =
    useMenuCheck();
  const [isDownloadBalanceSheetPresent, setIsDownloadBalanceSheetPresent] =
    useMenuCheck();
  const [redirectToCustomerSuplier, setRedirectToCustomerSuplier] =
    useState<boolean>(false);
  const [toggle, setToggle] = useState<boolean>(false);
  const [branchList, setBranchList] = useState<[] | BranchListType[]>([]);
  const [branchSelected, setBranchSelected] = useState<BranchListType>({
    value: "",
    label: "Select Branch...",
  });
  const [selectedBranchId, setSelectedBranchId] = useState<number | null>(null);
  const [branchName, setBranchName] = useState<string>("");

  const [
    showLedgerStatementDownloadModal,
    setShowLedgerStatementDownloadModal,
  ] = useState<boolean>(false);

  const [ledgerPdfStartDate, setLedgerPdfStartDate] = useState("");
  const [ledgerPdfEndDate, setLedgerPdfEndDate] = useState("");

  const [ledgerPdfDownloadButton, setLedgerPdfDownloadButton] =
    useState<boolean>(false);

  const [ledgerType, setLedgerType] = useState<string>("");

  useEffect(() => {
    setIsLedgerStatementPresent("Ledger Statement", "menu");
    setIsStocksStatementPresent("Stocks Statement", "menu");
    setIsDownloadBalanceSheetPresent("Download Balance Sheet", "menu");
    setIsEditCustomerSupplierPresent("Edit Customer/Supplier", "menu");
    setBranchList([]);
    setBranchName("");
    dispatchResetBusinessAddressList();
    dispatchGetAllBusinessAddressList({ token, client_code });
    dispatchResetReportsErrorAction();
    dispatchResetReportsSuccessAction();
    dispatchResetAssetsBalanceSheetData();
    dispatchResetSupplierBalanceSheetData();
    dispatchResetLiabilityBalanceSheetData();
    dispatchResetEquityBalanceSheetData();
    dispatchResetCustomerBalanceSheetData();
    dispatchResetPaymentBalanceSheetData();
    dispatchResetTaxPayableBalanceSheetData();
    dispatchResetTaxReceivableBalanceSheetData();
    dispatchResetStockSummaryBalanceSheetData();
    dispatchResetReportsFetchingAction();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    (equityBalanceSheetData?.length > 0 ||
      liabilitiesBalanceSheetData?.length > 0 ||
      supplierBalanceSheetData?.length > 0 ||
      customerBalanceSheetData?.length > 0 ||
      paymentBalanceSheetData?.length > 0 ||
      assetsBalanceSheetData?.length > 0) &&
    branchSelected?.label !== "Select Branch..."
      ? setBranchName(branchSelected?.label)
      : setBranchName("");
      //eslint-disable-next-line
  }, [
    equityBalanceSheetData,
    liabilitiesBalanceSheetData,
    supplierBalanceSheetData,
    customerBalanceSheetData,
    paymentBalanceSheetData,
    assetsBalanceSheetData,
  ]);

  useEffect(() => {
    if (businessAddressList && businessAddressList?.length > 0) {
      let finalBranchList: any[] = [];
      businessAddressList?.map((businessAddress: BusinessAddressListType) => {
        finalBranchList.push({
          value: businessAddress?.ledger_id,
          label: businessAddress?.trade_name,
        });
      });

      setBranchList(finalBranchList);
    }
  }, [businessAddressList]);

  useEffect(() => {
    if (date != displayDate) {
      setDisplayDate(formatDate(date));
    }
    //eslint-disable-next-line
  }, [
    assetsBalanceSheetData,
    liabilitiesBalanceSheetData,
    equityBalanceSheetData,
    customerBalanceSheetData,
    supplierBalanceSheetData,
    paymentBalanceSheetData,
  ]);

  useEffect(() => {
    if (balanceSheetTotal && Object.keys(balanceSheetTotal).length > 0) {
      //commented for future use
      // let tempLiabilitiesTotal =
      //   balanceSheetTotal?.liabilities_total_value < 0
      //     ? Math.abs(balanceSheetTotal?.liabilities_total_value)
      //     : `-${balanceSheetTotal?.liabilities_total_value}`;

      // let tempSupplierTotal =
      //   balanceSheetTotal?.supplier_total_value < 0
      //     ? Math.abs(balanceSheetTotal?.supplier_total_value)
      //     : `-${balanceSheetTotal?.supplier_total_value}`;

      // let tempEquityTotal =
      //   balanceSheetTotal?.equity_total_value < 0
      //     ? Math.abs(balanceSheetTotal?.equity_total_value)
      //     : `-${balanceSheetTotal?.equity_total_value}`;
      // let tempTaxPayableTotal =
      //   balanceSheetTotal?.tax_payable_value < 0
      //     ? Math.abs(balanceSheetTotal?.tax_payable_value)
      //     : `-${balanceSheetTotal?.tax_payable_value}`;

      let tempLiabilitiesTotal = balanceSheetTotal?.liabilities_total_value;

      let tempSupplierTotal = balanceSheetTotal?.supplier_total_value;

      let tempEquityTotal = balanceSheetTotal?.equity_total_value;
      let tempTaxPayableTotal = balanceSheetTotal?.tax_payable_value;

      let liabilitiesTempTotal =
        +tempLiabilitiesTotal +
        balanceSheetTotal?.net_profit +
        +tempEquityTotal +
        +tempSupplierTotal +
        +tempTaxPayableTotal;

      let finalLiabilitiesTotal =
        liabilitiesTempTotal && liabilitiesTempTotal < 0
          ? liabilitiesTempTotal
          : liabilitiesTempTotal;

      setLiabilitiesTotal(finalLiabilitiesTotal);

      let assetsTempTotal =
        balanceSheetTotal?.assets_total_value +
        balanceSheetTotal?.customer_total_value +
        balanceSheetTotal?.payment_total_value +
        balanceSheetTotal?.tax_receivable_value +
        (balanceSheetTotal?.total_stock_summary_value
          ? +balanceSheetTotal?.total_stock_summary_value
          : 0);

      let finalAssetsTotal =
        assetsTempTotal && assetsTempTotal < 0
          ? assetsTempTotal
          : assetsTempTotal;

      setAssetsTotal(finalAssetsTotal);
    }
  }, [balanceSheetTotal]);

  const handleDateChange = (date: any) => {
    const value = handleDate(date);
    setDate(value);
  };

  const handleSubmitData = () => {
    let finalData: GetBalanceSheetPayloadType = {
      token,
      client_code,
      date_value: formatDate(date),
      branch_id: selectedBranchId,
    };

    dispatchGetBalanceSheetAction(finalData);
  };

  const handleBranchChange = (data: BranchListType) => {
    setSelectedBranchId(+data?.value);
    setBranchSelected(data);
  };

  const handleLedgerStatementDownloadModal = () => {
    setLedgerPdfEndDate("");
    setLedgerPdfStartDate("");
    setShowLedgerStatementDownloadModal(!showLedgerStatementDownloadModal);
  };

  const handleLedgerStatementPdfStartDate = (date: string) => {
    if (date == "Invalid date") date = "";
    setLedgerPdfStartDate(date);
    if (ledgerPdfStartDate !== date) {
      setLedgerPdfEndDate("");
    }
  };

  const handleLedgerStatementPdfEndDate = (date: string) => {
    if (date == "Invalid date") date = "";
    setLedgerPdfEndDate(date);
  };

  const handleSetLedgerType = (type: string) => setLedgerType(type);

  const handleDownloadLedgerStatementPdf = () => {
    setLedgerPdfDownloadButton(true);
    let finalData: GetMultipleLedgerStatementPdfType = {
      token,
      type: ledgerType,
      client_code,
      start_date: formatDate(ledgerPdfStartDate),
      end_date: formatDate(ledgerPdfEndDate),
    };

    if (
      token &&
      finalData?.type &&
      finalData?.client_code &&
      finalData?.start_date &&
      finalData?.end_date
    ) {
      let pdfName = `${finalData?.type?.toUpperCase()}_ledger_statement_${
        finalData?.start_date
      }_${finalData?.end_date}`;

      getMultipleLedgerStatementPdfApi(finalData).then((response: any) => {
        let blob = new Blob([response.data], {
          type: "application/pdf",
        });

        FileSaver.saveAs(blob, pdfName);
        setShowLedgerStatementDownloadModal(false);
        setLedgerPdfStartDate("");
        setLedgerPdfEndDate("");
        setLedgerType("");
        setLedgerPdfDownloadButton(false);
        toast.success("Ledger Statement Downloaded Successfully!", {
          duration: 3000,
        });
      });
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetReportsErrorAction();
            }}
          />
        );
      }
    }

    return false;
  };

  const handlePrepareDownload = () => {
    let params: GetBalanceSheetPayloadType = {
      date_value: moment(date).format("DD-MM-YYYY"),
      client_code: client_code,
      branch_id: selectedBranchId,
      token,
    };

    if (params && token) {
      handleDownload(params);
    }
  };

  const handleDownload = (params: GetBalanceSheetPayloadType) => {
    let reportName = company_name
      ? company_name + "-" + moment(date).format("DD-MM-YYYY") + ".xlsx"
      : "report";
    downloadBalanceSheetApi(params).then((response: any) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
      });
      FileSaver.saveAs(blob, reportName);
      toast.success("Report Downloaded Successfully!", {
        duration: 3000,
      });
    });
  };

  const renderDownloadInvoiceToolTip = (props: any) => {
    return (
      <Tooltip id="button-view-open-item" {...props}>
        Download Excel
      </Tooltip>
    );
  };

  const handleCustomerSupliertoogle = () => {
    setShowModal(!showModal);
  };

  const handleCustomerSuplierDetailsData = (data: number) => {
    setShowModal(!showModal);
    if (token && client_code) {
      const finaldata = {
        token,
        client_code,
        customerSupplierId: data,
      };
      dispatchGetSingleCustomerSupplierAction(finaldata);
    }
  };

  return (
    <>
      <div className="col-md-6">
        <CommonHeader
          title="Balance Sheet"
          company_name={company_name}
          client_code={client_code}
        />
      </div>
      <div className="report-card mt-4 pt-3">
        <div className="inside-report-card">
          <BalanceSheetHeader
            setToggle={setToggle}
            toggle={toggle}
            handleDateChange={handleDateChange}
            date={date}
            handleSubmitData={handleSubmitData}
            branchList={branchList}
            branchSelected={branchSelected}
            handleBranchChange={handleBranchChange}
          />
          <hr className="mt-4 mb-4" />
          {assetsBalanceSheetData?.length === 0 &&
          equityBalanceSheetData?.length === 0 &&
          liabilitiesBalanceSheetData?.length === 0 &&
          supplierBalanceSheetData?.length === 0 &&
          customerBalanceSheetData?.length === 0 &&
          paymentBalanceSheetData?.length === 0 &&
          !fetching ? (
            <EmptyListPage
              title={`No Balance Sheet Found!`}
              text={`Choose a date to get Balance Sheet.`}
              image={BalanceSheetImage}
              imageWidth="30%"
            />
          ) : (
            <>
              <div className="d-flex">
                <div className="d-flex flex-column mb-3" style={{ flex: "22" }}>
                  <h5 className="text-center">Balance Sheet</h5>{" "}
                  <div className="d-flex justify-content-center">
                    <h5>{branchName && `Branch: ${branchName}`}</h5>
                  </div>
                  <div className="d-flex justify-content-center">
                    {displayDate && (
                      <h6 className="text-center mr-4">
                        As of:{" "}
                        <span className="font-weight-bolder">
                          {fetching ? (
                            <span>
                              <SkeltonElement type="title" />
                            </span>
                          ) : (
                            displayDate
                          )}
                        </span>
                      </h6>
                    )}
                  </div>
                </div>
                <div
                  className="d-flex align-items-center mr-2"
                  style={{ flex: "1" }}
                >
                  {isDownloadBalanceSheetPresent && (
                    <span className="mt-1">
                      <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 250 }}
                        overlay={renderDownloadInvoiceToolTip}
                      >
                        <button
                          style={{ border: "none", marginTop: "-6px" }}
                          onClick={handlePrepareDownload}
                        >
                          <Excel />
                        </button>
                      </OverlayTrigger>
                    </span>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <h5>Liabilities</h5>
                  <hr style={{ border: "1px solid #dd4433" }} />
                  <CapsHeader title="EQUITY" />
                  <BalanceSheetTable
                    data={equityBalanceSheetData}
                    dispatchResetAllTypeLedgerListWithTaxList={dispatchResetAllTypeLedgerListWithTaxList}
                    netAmount={balanceSheetTotal?.equity_total_value}
                    netAmountName={`Total Equity`}
                    fetching={fetching}
                    tableHeaders={BALANCE_SHEET_HEADERS}
                    netBalanceSheetProfit={balanceSheetTotal?.net_profit}
                    client_code={client_code}
                    company_name={company_name}
                    end_date={date}
                    currencySign={currencySign ? currencySign : ""}
                    isLedgerStatementPresent={isLedgerStatementPresent}
                    isStocksStatementPresent={isStocksStatementPresent}
                    selectedBranchId={selectedBranchId}
                    branchName={branchName}
                  />
                  <CapsHeader title="RETAINED EARNINGS" />
                  <table className="table table-bordered thead-light">
                    <tbody>
                      <tr
                        style={{
                          backgroundColor: "#eee",
                        }}
                      >
                        <th className="text-start">
                          <strong>LEDGER NAME</strong>
                        </th>
                        <th className="text-start">
                          <strong>CLOSING AMOUNT</strong>
                        </th>
                      </tr>
                      <tr
                        style={{
                          backgroundColor: "#fff",
                        }}
                      >
                        <td className="text-start">Retained Earnings</td>
                        <td className="text-start">
                          {/* {handleSetIcon()} */}
                          {currencySignAndNegativeValueAdjust(
                            currencySign,
                            balanceSheetTotal?.net_profit
                              ? balanceSheetTotal?.net_profit
                                  ?.toFixed(2)
                                  ?.toString()
                              : ""
                          )}
                          {/* {currencySign}
                          {balanceSheetTotal?.net_profit} */}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <CapsHeader title="LIABILITIES" />
                  <BalanceSheetTable
                    data={liabilitiesBalanceSheetData}
                    dispatchResetAllTypeLedgerListWithTaxList={dispatchResetAllTypeLedgerListWithTaxList}
                    netAmount={balanceSheetTotal?.liabilities_total_value}
                    netAmountName={`Total Liabilities`}
                    fetching={fetching}
                    tableHeaders={BALANCE_SHEET_HEADERS}
                    client_code={client_code}
                    company_name={company_name}
                    end_date={date}
                    isLedgerStatementPresent={isLedgerStatementPresent}
                    currencySign={currencySign ? currencySign : ""}
                    isStocksStatementPresent={isStocksStatementPresent}
                    selectedBranchId={selectedBranchId}
                    branchName={branchName}

                  />
                  <CapsHeader title="TAX PAYABLE" />
                  <BalanceSheetTable
                    data={taxPayableBalanceSheetData}
                    dispatchResetAllTypeLedgerListWithTaxList={dispatchResetAllTypeLedgerListWithTaxList}
                    netAmount={balanceSheetTotal?.tax_payable_value}
                    netAmountName={`Total Tax Payable`}
                    fetching={fetching}
                    tableHeaders={BALANCE_SHEET_HEADERS}
                    client_code={client_code}
                    company_name={company_name}
                    end_date={date}
                    isLedgerStatementPresent={isLedgerStatementPresent}
                    currencySign={currencySign ? currencySign : ""}
                    isStocksStatementPresent={isStocksStatementPresent}
                    selectedBranchId={selectedBranchId}
                    branchName={branchName}

                  />
                  <CapsHeader
                    title="SUPPLIER"
                    showDownloadLedgerPdf
                    handleLedgerStatementDownloadModal={
                      handleLedgerStatementDownloadModal
                    }
                    handleSetLedgerType={handleSetLedgerType}
                  />
                  <BalanceSheetTable
                    title="supplier"
                    data={supplierBalanceSheetData}
                    dispatchResetAllTypeLedgerListWithTaxList={dispatchResetAllTypeLedgerListWithTaxList}
                    netAmount={balanceSheetTotal?.supplier_total_value}
                    netAmountName={`Total Supplier Amount`}
                    fetching={fetching}
                    tableHeaders={BALANCE_SHEET_HEADERS}
                    client_code={client_code}
                    company_name={company_name}
                    end_date={date}
                    isLedgerStatementPresent={isLedgerStatementPresent}
                    handleCustomerSuplierDetailsData={
                      handleCustomerSuplierDetailsData
                    }
                    currencySign={currencySign ? currencySign : ""}
                    isStocksStatementPresent={isStocksStatementPresent}
                    selectedBranchId={selectedBranchId}
                    branchName={branchName}

                  />
                </div>
                <div className="col-md-6">
                  <h5>Assets</h5>
                  <hr style={{ border: "1px solid #dd4433" }} />
                  <CapsHeader title="ASSETS" />
                  <BalanceSheetTable
                    data={assetsBalanceSheetData}
                    dispatchResetAllTypeLedgerListWithTaxList={dispatchResetAllTypeLedgerListWithTaxList}
                    netAmount={balanceSheetTotal?.assets_total_value}
                    netAmountName={`Total Assets`}
                    fetching={fetching}
                    tableHeaders={BALANCE_SHEET_HEADERS}
                    client_code={client_code}
                    company_name={company_name}
                    end_date={date}
                    isLedgerStatementPresent={isLedgerStatementPresent}
                    currencySign={currencySign ? currencySign : ""}
                    isStocksStatementPresent={isStocksStatementPresent}
                    selectedBranchId={selectedBranchId}
                    branchName={branchName}

                  />
                  <CapsHeader
                    title="CUSTOMER"
                    showDownloadLedgerPdf
                    handleLedgerStatementDownloadModal={
                      handleLedgerStatementDownloadModal
                    }
                    handleSetLedgerType={handleSetLedgerType}
                  />
                  <BalanceSheetTable
                    title="customer"
                    data={customerBalanceSheetData}
                    dispatchResetAllTypeLedgerListWithTaxList={dispatchResetAllTypeLedgerListWithTaxList}
                    netAmount={balanceSheetTotal?.customer_total_value}
                    netAmountName={`Total Customer Amount`}
                    fetching={fetching}
                    tableHeaders={BALANCE_SHEET_HEADERS}
                    client_code={client_code}
                    company_name={company_name}
                    end_date={date}
                    isLedgerStatementPresent={isLedgerStatementPresent}
                    currencySign={currencySign ? currencySign : ""}
                    handleCustomerSuplierDetailsData={
                      handleCustomerSuplierDetailsData
                    }
                    isStocksStatementPresent={isStocksStatementPresent}
                    selectedBranchId={selectedBranchId}
                    branchName={branchName}

                  />
                  <CapsHeader title="TAX RECEIVABLE" />
                  <BalanceSheetTable
                    data={taxReceiveableBalanceSheetData}
                    dispatchResetAllTypeLedgerListWithTaxList={dispatchResetAllTypeLedgerListWithTaxList}
                    netAmount={balanceSheetTotal?.tax_receivable_value}
                    netAmountName={`Total Tax Receivable`}
                    fetching={fetching}
                    tableHeaders={BALANCE_SHEET_HEADERS}
                    client_code={client_code}
                    company_name={company_name}
                    end_date={date}
                    currencySign={currencySign ? currencySign : ""}
                    isLedgerStatementPresent={isLedgerStatementPresent}
                    isStocksStatementPresent={isStocksStatementPresent}
                    selectedBranchId={selectedBranchId}
                    branchName={branchName}

                  />

                  {!!balanceSheetTotal?.total_stock_summary_value ? (
                    <>
                      <CapsHeader title="INVENTORY" />
                      <BalanceSheetTable
                        data={stockSummaryBalanceSheetData}
                        dispatchResetAllTypeLedgerListWithTaxList={dispatchResetAllTypeLedgerListWithTaxList}
                        netAmount={balanceSheetTotal?.total_stock_summary_value}
                        netAmountName={`Total Inventory`}
                        fetching={fetching}
                        tableHeaders={BALANCE_SHEET_STOCK_SUMMARY_HEADERS}
                        netBalanceSheetProfit={
                          balanceSheetTotal?.total_stock_summary_value
                        }
                        client_code={client_code}
                        company_name={company_name}
                        end_date={date}
                        currencySign={currencySign ? currencySign : ""}
                        isLedgerStatementPresent={isLedgerStatementPresent}
                        isStocksStatementPresent={isStocksStatementPresent}
                        selectedBranchId={selectedBranchId}
                        branchName={branchName}

                      />{" "}
                    </>
                  ) : null}

                  <CapsHeader title={`CASH & CASH EQUIVALENTS`} />
                  <BalanceSheetTable
                    data={paymentBalanceSheetData}
                    dispatchResetAllTypeLedgerListWithTaxList={dispatchResetAllTypeLedgerListWithTaxList}
                    netAmount={balanceSheetTotal?.payment_total_value}
                    netAmountName={`Total Payment`}
                    fetching={fetching}
                    tableHeaders={BALANCE_SHEET_HEADERS}
                    client_code={client_code}
                    company_name={company_name}
                    end_date={date}
                    currencySign={currencySign ? currencySign : ""}
                    isLedgerStatementPresent={isLedgerStatementPresent}
                    isStocksStatementPresent={isStocksStatementPresent}
                                        selectedBranchId={selectedBranchId}
                                        branchName={branchName}

                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="">
                    <div
                      style={{
                        backgroundColor: "#dd4433",
                        padding: "6px 8px",
                        color: "#fff",
                        fontSize: "16px",
                        marginTop: "20px",
                        position: "relative",
                        display: "flex",
                        justifyContent: "space-around",
                      }}
                    >
                      TOTAL:
                      <div>
                        <strong>
                          {currencySignAndNegativeValueAdjust(
                            currencySign,
                            liabilitiesTotal
                              ? liabilitiesTotal?.toFixed(2)?.toString()
                              : ""
                          )}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="">
                    <div
                      style={{
                        backgroundColor: "#dd4433",
                        padding: "6px 8px",
                        color: "#fff",
                        fontSize: "16px",
                        marginTop: "20px",
                        position: "relative",
                        display: "flex",
                        justifyContent: "space-around",
                      }}
                    >
                      TOTAL:
                      <span>
                        <strong>
                          {currencySignAndNegativeValueAdjust(
                            currencySign,
                            assetsTotal
                              ? assetsTotal?.toFixed(2)?.toString()
                              : ""
                          )}
                        </strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      {handleErrorModal()}
      {showLedgerStatementDownloadModal && (
        <LedgerDownloadModal
          isOpen={showLedgerStatementDownloadModal}
          handleLedgerStatementDownloadModal={
            handleLedgerStatementDownloadModal
          }
          handleDownloadLedgerStatementPdf={handleDownloadLedgerStatementPdf}
          ledgerPdfStartDate={ledgerPdfStartDate}
          ledgerPdfEndDate={ledgerPdfEndDate}
          handleLedgerStatementPdfStartDate={handleLedgerStatementPdfStartDate}
          handleLedgerStatementPdfEndDate={handleLedgerStatementPdfEndDate}
          ledgerPdfDownloadButton={ledgerPdfDownloadButton}
          ledgerType={ledgerType?.toUpperCase()}
        />
      )}
      {showModal && (
        <ViewEditCustomerSuplierModal
          isOpen={showModal}
          isEditCustomerSupplierPresent={isEditCustomerSupplierPresent}
          setRedirectToCustomerSuplier={setRedirectToCustomerSuplier}
          fetching={customerSuplierFetching}
          client_code={client_code}
          company_name={company_name}
          toggle={handleCustomerSupliertoogle}
          singleCustomerSupplier={singleCustomerSupplier}
          currencySign={currencySign}
        />
      )}
      <Toaster />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.reports.fetching,
  error: state.reports.error,
  statusCode: state.reports.statusCode,
  success: state.reports.success,
  assetsBalanceSheetData: state.reports.assetsBalanceSheetData,
  liabilitiesBalanceSheetData: state.reports.liabilitiesBalanceSheetData,
  equityBalanceSheetData: state.reports.equityBalanceSheetData,
  paymentBalanceSheetData: state.reports.paymentBalanceSheetData,
  supplierBalanceSheetData: state.reports.supplierBalanceSheetData,
  customerBalanceSheetData: state.reports.customerBalanceSheetData,
  taxPayableBalanceSheetData: state.reports.taxPayableBalanceSheetData,
  taxReceiveableBalanceSheetData: state.reports.taxReceivableBalanceSheetData,
  stockSummaryBalanceSheetData: state.reports.stockSummaryBalanceSheetData,
  balanceSheetTotal: state.reports.balanceSheetTotal,
  customerSuplierFetching: state.clientSettings.fetching,
  singleCustomerSupplier: state.clientSettings.singleCustomerSupplier,
  currencySign: state.auth.currencySign,
  companyName: state.auth.companyName,
  businessAddressList: state.clientSettings.businessAddressList,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetReportsErrorAction: () => dispatch(resetReportsError()),
  dispatchResetReportsSuccessAction: () => dispatch(resetReportsSuccess()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetBalanceSheetAction: (data: GetBalanceSheetPayloadType) =>
    dispatch(getBalanceSheetAction(data)),
  dispatchResetCustomerBalanceSheetData: () =>
    dispatch(resetCustomerBalanceSheetData()),
  dispatchResetSupplierBalanceSheetData: () =>
    dispatch(resetSupplierBalanceSheetData()),
  dispatchResetPaymentBalanceSheetData: () =>
    dispatch(resetPaymentBalanceSheetData()),
  dispatchResetEquityBalanceSheetData: () =>
    dispatch(resetEquityBalanceSheetData()),
  dispatchResetAssetsBalanceSheetData: () =>
    dispatch(resetAssetsBalanceSheetData()),
  dispatchResetLiabilityBalanceSheetData: () =>
    dispatch(resetLiabilitiesBalanceSheetData()),
  dispatchResetTaxPayableBalanceSheetData: () =>
    dispatch(resetTaxPayableBalanceSheetData()),
  dispatchResetTaxReceivableBalanceSheetData: () =>
    dispatch(resetTaxReceivableBalanceSheetData()),
  dispatchResetStockSummaryBalanceSheetData: () =>
    dispatch(resetStockSummaryBalanceSheetData()),
  dispatchGetSingleCustomerSupplierAction: (
    data: GetSingleCustomerSupplierListPayloadType
  ) => dispatch(getSingleCustomerSupplierAction(data)),
  dispatchResetReportsFetchingAction: () => dispatch(resetReportsFetching()),
  dispatchGetAllBusinessAddressList: (
    data: GetAllBussinessAddressesListPayloadType
  ) => dispatch(getAllBusinessAddressAction(data)),
  dispatchResetBusinessAddressList: () => dispatch(resetBusinessAddressList()),
  dispatchResetAllTypeLedgerListWithTaxList: () => dispatch(resetAllTypesLedgerListWithTaxList())
});

export default connect(mapStateToProps, mapDispatchToProps)(BalanceSheet);
